module.exports = "<div class=\"box\">\n  <div class=\"spinner type1\">\n    <span>Loading...</span>\n  </div>\n</div>\n"